module.exports = __webpack_public_path__ + "static/media/3_MIAB9825-180730-119_Small.cc550feb.jpg";